import { request } from '../../../../global/services/request'
import { ContactForm } from '../store/store'

export async function getContacts(accountId: string) {
  return await request({
    path: `/accounts/${accountId}/contacts`,
    method: 'GET'
  })
}

export async function postContact(accountId: string, contactFields: ContactForm) {
  return await request({
    path: `/accounts/${accountId}/contacts`,
    method: 'POST',
    body: {
      name: contactFields.name.trim(),
      email: contactFields.email.trim(),
      phone: contactFields.phone.trim(),
      mobile: contactFields.mobile.trim() 
    }
  })
}

export async function updateContact(accountId: string, contactId: string, contactFields: ContactForm) {
  return await request({
    path: `/accounts/${accountId}/contacts/${contactId}`,
    method: 'PATCH',
    body: {
      name: contactFields.name.trim(),
      email: contactFields.email.trim(),
      phone: contactFields.phone.trim(),
      mobile: contactFields.mobile.trim() 
    }
  })
}

export async function deleteContact(accountId: string, contactId: string) {
  return await request({
    path: `/accounts/${accountId}/contacts/${contactId}`,
    method: 'DELETE'
  })
}
